import {
    SectionedCard,
    StatCardProps,
    TimeseriesChart,
    TimeseriesChartProps,
    ToggleStatButtons
} from "@bridgesplit/ui";

// Shared shell for a stat-toggle chart: a `ToggleStatButtons` header over a single `TimeseriesChart`.
// The parent owns tab state and the time window so it can read every tab's data source unconditionally
// and pass in the selected tab's config, meaning toggling never refetches.
export function ToggleTimeseriesChart<Tab extends string, T extends { date: number }>({
    options,
    value,
    setValue,
    chartConfig,
    period,
    setPeriod,
    xDomain,
    height = 200
}: {
    options: Partial<Record<Tab, StatCardProps>>;
    value: Tab;
    setValue: (value: Tab) => void;
    chartConfig: TimeseriesChartProps<T>;
    period?: number;
    setPeriod?: (period: number) => void;
    xDomain?: [number, number];
    height?: number;
}) {
    return (
        <SectionedCard>
            <ToggleStatButtons variant="default" size="small" value={value} setValue={setValue} options={options} />
            <TimeseriesChart<T>
                height={height}
                {...chartConfig}
                xDomain={xDomain}
                period={period}
                setPeriod={setPeriod}
            />
        </SectionedCard>
    );
}
